import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions} from '@angular/http';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { ENPOINT } from '../endpoint';

import { Options } from 'selenium-webdriver/safari';
import { GLOBAL } from '../global';

@Injectable()
export class EstatusCargaFacturasService {


  constructor(
    private http: HttpClient,
    
  ) {}
  public url = GLOBAL.url;
  private basePath = ENPOINT.url;
  
  obtenerFacturasCargadas(usuario): Observable<any> {

    const httpHeaders = new HttpHeaders()
    const options = {
      headers: httpHeaders,
      withCredentials: true
    };

    return this.http.get(this.basePath + 'facturas-batch/'+usuario, options);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/status-uploadInvoices/estatus-cargaFacturas.service.ts